<app-full-loader></app-full-loader>
<p-toast></p-toast>
<router-outlet></router-outlet>